import { render, staticRenderFns } from "./DailyCouponNew.vue?vue&type=template&id=184bbb84&scoped=true&"
import script from "./DailyCouponNew.vue?vue&type=script&lang=js&"
export * from "./DailyCouponNew.vue?vue&type=script&lang=js&"
import style0 from "./DailyCouponNew.vue?vue&type=style&index=0&id=184bbb84&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184bbb84",
  null
  
)

export default component.exports